import { AccountMpnId } from '../../models';
import { FetchContext, responseErrorHandler } from '..';

export const getCurrentUserPartnerIds: (
  fetchContext: FetchContext,
  userId: number,
  accessToken?: string,
) => Promise<AccountMpnId[]> = (fetchContext, userId, accessToken) => fetch(`${fetchContext.baseUrl}/api/me/${userId}/partnerids`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<AccountMpnId[]>(fetchContext.errorStore, response, 'get current user partner ids'));
